import React from "react";

import "./checklistRow.css";

// Linha + badge do checklist orientado a status. Extraídos de
// views/Admin/OnboardingEmbarcador/components/ChecklistHome.jsx (PO1-2428)
// para o painel de habilitação da transportadora (PO1-3106) reusar o mesmo
// visual. Classes onb-* continuam as mesmas; o ChecklistHome importa daqui.

export function Badge({ tipo, children }) {
  return <span className={`onb-badge ${tipo}`}>{children}</span>;
}

export default function Row({ numero, titulo, sub, badge, badgeTipo, done, locked, onClick, children }) {
  const clicavel = !locked && typeof onClick === "function";
  return (
    <div
      className={`onb-clrow${done ? " is-done" : ""}${locked ? " locked" : ""}${clicavel ? "" : " static"}`}
      onClick={clicavel ? onClick : undefined}
      role={clicavel ? "button" : undefined}
      tabIndex={clicavel ? 0 : undefined}
      onKeyPress={clicavel ? onClick : undefined}
    >
      <div className="onb-clnum">{numero}</div>
      <div className="onb-cltext">
        <div className="onb-cltitle">{titulo}</div>
        {sub ? <div className="onb-clsub">{sub}</div> : null}
        {children}
      </div>
      <Badge tipo={badgeTipo}>{badge}</Badge>
      {clicavel ? <span style={{ color: "#9a9a9a" }}>▸</span> : null}
    </div>
  );
}
